import Vue from 'vue'
import App from './App.vue'
import crypto from './crypto/crypto'//前端加密（缓存加密、路由参数加密）
import cryptohttp from './crypto/cryptoencrypt'
import router from './router'
import store from './store'
import axios from 'axios'
import plug from './plug/index'
import Http from './http/index'
import HttpsEncrypt from './http/indexencrypt'//接口加密
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.$crypto = crypto
Vue.prototype.$cryptohttp = cryptohttp

//引入video样式
import VideoPlayer from 'vue-video-player'

import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
//引入hls.js
import 'videojs-contrib-hls.js/src/videojs.hlsjs'

Vue.use(VideoPlayer)

// 打印
import Print from 'vue-print-nb'
Vue.use(Print); //注册


Vue.prototype.axios = axios;
axios.defaults.baseURL = '/api'
Vue.prototype.$http = Http
Vue.prototype.$httpsencrypt = HttpsEncrypt
Vue.use(plug)
Vue.use(iView)
Vue.use(VueI18n)
Vue.use(ElementUI);


import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
    ak: 'LLn5Q9UemGwfly5CE2nlWhjIEvZsKZfi'//自己去百度API申请，免费的
})


const i18n = new VueI18n({
    locale: 'mn',    // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
        'zh': require('./assets/lang/zh'),   // 中文语言包
        'mn': require('./assets/lang/mn'),    // 英文语言包
        'en': require('./assets/lang/en')    // 英文语言包
    }
})


import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: require('./assets/images/default.jpg'),
    loading: require('./assets/images/loading.gif'),
    lazyComponent: true
})
/************************************************************
 *
 * 检索时失去焦点
 *
 ************************************************************/
Vue.prototype.$getOnBlur = function (data) {
    let old = data.trim()
    // // 奥云
    // let aoyun = '\s+ᠵᠢᠨ|\s+᠊ᠤᠨ|\s+᠊ᠦ|\s+ᠳ᠋ᠤ᠌|\s+ᠲᠤ᠌|\s+ᠶ᠋ᠢ|\s+᠊ᠢ|\s+ᠠ᠋ᠴᠠ|\s+ᠲᠠᠢ|\s+ᠪᠠᠷ|\s+ᠵᠢᠠᠷ|\s+ᠪᠡᠨ|\s+ᠵᠢᠠᠨ|\s+ᠳ᠋ᠦ᠍ᠷ|\s+ᠲᠤᠷ|s+᠊ᠤᠤ'
    // // 德力海
    // let delihai = '|\s+ᠢᠨ|\s+᠎ᠤᠨ|\s+᠎ᠤ|\s+᠎ᠢ|\s+ᠵᠢ|\s+᠎ᠳᠤ|\s+᠎ᠲᠤ|\s+᠎ᠲᠠᠢ|\s+᠎ᠡᠴᠡ|\s+᠎ᠪᠡᠷ|\s+᠎ᠢᠶᠡᠨ|\s+᠎ᠪᠡᠨ|\s+᠎ᠢᠶᠡᠷ|\s+᠎ᠳᠤᠷ|\s+᠎ᠲᠤᠷ'
    // // 蒙科力标准
    // let mklbz = '|\s+ᠤᠨ|\s+ᠪᠠᠷ|\s+ᠶ᠋ᠢ|\s+ᠪᠠᠷ|\s+ᠪᠠᠨ|\s+ᠤᠳ|\s+ᠦᠦ'
    // // 蒙科力
    // let mkl = '|\s+ᠶᠢᠨ|\s+᠎ᠤᠨ|\s+᠎ᠤ|\s+᠎ᠳ᠋ᠦ᠍|\s+᠎ᠲᠤ|\s+ᠶᠢ|\s+᠎ᠢ|\s+᠎ᠡᠴᠡ|\s+᠎ᠲᠠᠢ|\s+᠎ᠪᠠᠷ|\s+᠎ᠢᠶᠡᠷ|\s+᠎ᠪᠠᠨ|\s+᠎ᠢᠶᠡᠨ|\s+ᠦᠦ'
    let reg = /\s+ᠵᠢᠨ|\s+᠊ᠤᠨ|\s+᠊ᠦ|\s+ᠳ᠋ᠤ᠌|\s+ᠲᠤ᠌|\s+ᠶ᠋ᠢ|\s+᠊ᠢ|\s+ᠠ᠋ᠴᠠ|\s+ᠲᠠᠢ|\s+ᠪᠠᠷ|\s+ᠵᠢᠠᠷ|\s+ᠪᠡᠨ|\s+ᠵᠢᠠᠨ|\s+ᠳ᠋ᠦ᠍ᠷ|\s+ᠲᠤᠷ|s+᠊ᠤᠤ|\s+ᠢᠨ|\s+᠎ᠤᠨ|\s+᠎ᠤ|\s+᠎ᠢ|\s+ᠵᠢ|\s+᠎ᠳᠤ|\s+᠎ᠲᠤ|\s+᠎ᠲᠠᠢ|\s+᠎ᠡᠴᠡ|\s+᠎ᠪᠡᠷ|\s+᠎ᠢᠶᠡᠨ|\s+᠎ᠪᠡᠨ|\s+᠎ᠢᠶᠡᠷ|\s+᠎ᠳᠤᠷ|\s+᠎ᠲᠤᠷ|\s+ᠤᠨ|\s+ᠪᠠᠷ|\s+ᠶ᠋ᠢ|\s+ᠪᠠᠷ|\s+ᠪᠠᠨ|\s+ᠤᠳ|\s+ᠦᠦ|\s+ᠶᠢᠨ|\s+᠎ᠤᠨ|\s+᠎ᠤ|\s+᠎ᠳ᠋ᠦ᠍|\s+᠎ᠲᠤ|\s+ᠶᠢ|\s+᠎ᠢ|\s+᠎ᠡᠴᠡ|\s+᠎ᠲᠠᠢ|\s+᠎ᠪᠠᠷ|\s+᠎ᠢᠶᠡᠷ|\s+᠎ᠪᠠᠨ|\s+᠎ᠢᠶᠡᠨ|\s+ᠦᠦ/g
    let ss = old.replace(reg, "-");
    let ll = ss.split("-").filter(item => item).join(" ")
    let ss1 = ll.replace(/\s+/g, "-")
    let ll1 = ss1.split("-").filter(item => item).join(" ")
    return ll1
}
/************************************************************
 *
 * 对手机号身份证号加密
 *
 ************************************************************/
Vue.prototype.$getNumberEncrypt = function (val, front = 3, after = 4) {
    return val.substring(0, front) + '*'.repeat(val.length - (front + after)) + val.substring(val.length - after)
}

Vue.prototype.$loginPd = function () {
    if (localStorage.getItem('userData') && JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userData'))).login_id) {
        let cond = {
            login_id:JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userData'))).login_id
        }
        HttpsEncrypt.post('api/web/v3/member/getsigndata',cond).then(val => {
            if (val.code == 200 && val.data.quit_at) {
                Vm.$Notice.error({
                    title: '登录超时',
                    desc: '请重新登录'
                })
                Vm.$router.push({path:'/login',query:{lib:Vm.$route.query.lib,alis:Vm.$route.query.alis}})
                Vm.$clearLocalStorageExceptActivePages()
                sessionStorage.clear()
                Vm.$store.state.tabList = '[]'
                Vm.$store.state.userInfo = ''
            } else {
                if (localStorage.getItem('userData')) {
                    let userDatas = JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userData')))
                    let last_login_time = userDatas.last_login_time
                    if (last_login_time) {
                        const date = new Date(last_login_time);
                        const timestamp = Math.floor(date.getTime() / 1000);
                        let d = Math.floor(new Date().getTime() / 1000);
                        let hhh = d - timestamp

                        if (hhh >= 21600) {
                            // 6小时
                            Vm.$Notice.error({
                                title: '登录超时',
                                desc: '请重新登录'
                            })
                            Vm.$router.push({path: '/login', query: {lib: Vm.$route.query.lib,alis:Vm.$route.query.alis}})
                            Vm.$clearLocalStorageExceptActivePages()
                            sessionStorage.clear()
                            Vm.$store.state.tabList = '[]'
                            Vm.$store.state.userInfo = ''
                        }
                    }
                }
            }

        }).catch(err => {
        })
    }
    if (localStorage.getItem('userData') && !JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userData'))).login_id) {
        Vm.$Notice.error({
            title: '登录超时',
            desc: '请重新登录'
        })
        Vm.$router.push({path: '/login', query: {lib: Vm.$route.query.lib,alis:Vm.$route.query.alis}})
       Vm.$clearLocalStorageExceptActivePages()
        sessionStorage.clear()
        Vm.$store.state.tabList = '[]'
        Vm.$store.state.userInfo = ''
    }
}

// 清空 localStorage，但保留 key 包含 "active_page_" 的项
Vue.prototype.$clearLocalStorageExceptActivePages = function (){
    // 获取所有 localStorage 的 key
    const keys = Object.keys(localStorage);
    // 遍历并删除不符合条件的 key
    keys.forEach(key => {
        if (!key.includes('active_page')) {
            localStorage.removeItem(key);
        }
    });
}

Vue.config.productionTip = false
Vue.prototype.$UserBehaviorsort = 0

router.beforeEach((to, from, next) => {
    if (to.path != '/login') {
        Vue.prototype.$RecordNum = 0 //判断近义词页面只走一次登录判断接口
    }

    window.addEventListener("beforeunload", () => {
        //页面刷新了
        Vue.prototype.$UserBehaviorsort = 0
    })
    if (sessionStorage.getItem('isNewVisit') === null) {
        //页面是新开的
        Vue.prototype.$UserBehaviorsort = 0
        sessionStorage.setItem('isNewVisit', 'false');
    } else {
        //页面不是新开的
    }

    // store.dispatch('getSebeihao').then(() => {
    // })


    if(to.query.lib&&localStorage.getItem('libId')&&(Vue.prototype.$crypto.get(decodeURIComponent(to.query.lib))!=localStorage.getItem('libId'))
    ||(to.query.alis&&localStorage.getItem('gjType')&&(Vue.prototype.$crypto.get(decodeURIComponent(to.query.alis))!=localStorage.getItem('gjType')))
    ){
        Vue.prototype.$clearLocalStorageExceptActivePages()
        sessionStorage.clear()
        store.state.tabList = '[]'
        store.state.userInfo = ''
        next({path:'/login',query:{lib:to.query.lib?to.query.lib:(from.query.lib?from.query.lib:''),alis:to.query.alis?to.query.alis:(from.query.alis?from.query.alis:'')}})
    }

    if(!localStorage.getItem('libId')&&to.query.lib){
        localStorage.setItem('libId',Vue.prototype.$crypto.get(decodeURIComponent(to.query.lib)))
    }
    if(!localStorage.getItem('gjType')&&to.query.alis){
        localStorage.setItem('gjType',Vue.prototype.$crypto.get(decodeURIComponent(to.query.alis)))
    }



    if (to.path != '/login') {
        if(!localStorage.getItem('libId')||!localStorage.getItem('gjType')){
            next('/login')
        }else if (!localStorage.getItem('userInfoMemberId')) {
            Vue.prototype.$clearLocalStorageExceptActivePages()
            sessionStorage.clear()
            Vm.$store.state.tabList = '[]'
            Vm.$store.state.userInfo = ''
            next({path:'/login',query:{lib:to.query.lib?to.query.lib:(from.query.lib?from.query.lib:''),alis:to.query.alis?to.query.alis:(from.query.alis?from.query.alis:'')}})
        } else {
            next()
        }

    } else if (to.path == '/login') {
        next()
    } else {
        if (localStorage.getItem('userData')) {
            next()
        }
    }


})
router.afterEach(route => {
    if (Vm.$route.path != '/login') {
        Vue.prototype.$loginPd()
    }
    if(localStorage.getItem('libId')==776&&localStorage.getItem('gjType')=='zheshe'){
        document.title = '哲学社会科学版蒙古文'
    }else if(localStorage.getItem('libId')==776&&localStorage.getItem('gjType')=='ziran'){
        document.title = '自然科学版蒙古文'
    }else {
        document.title = '投审系统'
    }

})
window.Vm = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
